import { render, staticRenderFns } from "./bottomButton.vue?vue&type=template&id=6120afae&scoped=true&"
import script from "./bottomButton.vue?vue&type=script&lang=js&"
export * from "./bottomButton.vue?vue&type=script&lang=js&"
import style0 from "./bottomButton.vue?vue&type=style&index=0&id=6120afae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120afae",
  null
  
)

export default component.exports